'use client';
import { FontWeightToStyles } from '../../util/font.js';

const getSelectStyles = ({ fontWeight }) => `${FontWeightToStyles[fontWeight]}`;

export { getSelectStyles };
//# sourceMappingURL=constants.js.map
